<template>
	<div class="title-with-weight-target-container">
		<div class="title-with-weight-target-container__title"><slot></slot></div>
		<span class="title-with-weight-target-container__target" v-if="hasTarget" v-html="targetString"></span>
	</div>
</template>

<style lang="scss" scoped>
.title-with-weight-target-container {
	text-align: center;
	margin-top: 1.5rem;

	&__title {
		font-weight: 900;
		font-size: 2.1rem;
		line-height: 1.2;
	}

	&__target {
		display: block;
		margin-top: 12px;
		font-weight: 500;
		font-size: 1.5rem;
		line-height: 21px;
		color: #323653;
	}
}
</style>

<script>
import { computed } from '@vue/reactivity'
import { useI18n } from 'vue-i18n'
import addDays from 'date-fns/addDays'
import format from 'date-fns/format'

export default {
	name: 'TitleWithWeightTarget',
	props: {
		userData: {
			type: Object,
			default: () => ({})
		}
	},
	setup(props) {
		const { t } = useI18n()

		const hasTarget = computed(() =>
			Boolean(
				props.userData &&
					props.userData.data &&
					props.userData.targetWeight &&
					props.userData.data.predictiveWeightLossDaysToGoal
			)
		)

		const date = computed(() => {
			if (!hasTarget.value) return ''
			return format(addDays(Date.now(), props.userData.data.predictiveWeightLossDaysToGoal), 'MMMM d')
		})

		const weight = computed(() => {
			if (!hasTarget.value) return ''
			const result = props.userData.weight - props.userData.targetWeight
			return Math.trunc(isKg.value ? result : result * 2.205).toString()
		})

		const isKg = computed(() => {
			if (!hasTarget.value) return false
			return props.userData.usesMetricSystem
		})

		const targetString = computed(() => {
			return t('title.weight_target.subtitle', {
				weight: weight.value,
				date: date.value,
				measurment: isKg.value ? 'kg' : 'lbs'
			})
		})

		return {
			hasTarget,
			targetString
		}
	}
}
</script>
